import { useFlags } from "launchdarkly-react-client-sdk";

interface LaunchDarklyFlags {
  enableLinkedPassenger: boolean;
  editStopInfo: boolean;
  enableVehicleCategory: boolean;
  enableSalesPipeline: boolean;
  enableCustomLocation: boolean;
}

export function useLaunchDarklyFlags(): Partial<LaunchDarklyFlags> {
  return useFlags();
}
